import { api } from "../../../../services/api";
import { getResponseError, handleApiErrorResponse, INTERNAL_SERVER_ERROR_MSG, transformApiResponse } from "../../../../utils/api";
export const LOGIN_PATH = "/auth/login";
export const loginApi = api
    .injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation({
            query: (request) => ({
                url: LOGIN_PATH,
                method: "POST",
                body: request
            }),
            transformResponse: (response) => transformApiResponse(response),
            transformErrorResponse: (response) => {
                var _a;
                return handleApiErrorResponse((_a = getResponseError(response)) !== null && _a !== void 0 ? _a : INTERNAL_SERVER_ERROR_MSG);
            }
        }),
        keepSessionAlive: build.query({
            query: () => ({
                url: `${LOGIN_PATH}/keepalive`
            }),
            transformResponse: (response) => transformApiResponse(response),
            transformErrorResponse: (response) => {
                var _a;
                return handleApiErrorResponse((_a = getResponseError(response)) !== null && _a !== void 0 ? _a : INTERNAL_SERVER_ERROR_MSG);
            }
        })
    })
});
export const { useLoginMutation, useLazyKeepSessionAliveQuery } = loginApi;
